import { __assign, __extends, __rest } from "tslib";
import color from 'color';
import * as React from 'react';
import { I18nManager } from 'react-native';
import configureFonts from "../styles/fonts";
import PnmacText from './PnmacText';
var fonts = configureFonts();
var PnmacStyledText = /** @class */function (_super) {
  __extends(PnmacStyledText, _super);
  function PnmacStyledText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacStyledText.prototype.render = function () {
    var _a = this.props,
      theme = _a.theme,
      alpha = _a.alpha,
      family = _a.family,
      style = _a.style,
      rest = __rest(_a, ["theme", "alpha", "family", "style"]);
    var textColor = color("#003087").alpha(alpha).rgb().string();
    var font = fonts[family];
    var writingDirection = I18nManager.isRTL ? 'rtl' : 'ltr';
    return /*#__PURE__*/React.createElement(PnmacText, __assign({}, rest, {
      style: [__assign(__assign({
        color: textColor
      }, font), {
        textAlign: 'left',
        writingDirection: writingDirection
      }), style, this.props.style]
    }));
  };
  return PnmacStyledText;
}(React.Component);
export default PnmacStyledText;